<template>
    <div v-if="hasMore" class="load-more">
        <button
            class="load-more__btn"
            :class="{ 'load-more__btn--loading': loading }"
            :disabled="loading"
            @click="emit('load')"
        >
            <span v-if="loading" class="load-more__spinner" />
            <span v-else class="load-more__icon">
                <MIcon icon="chevron-down" :size="20" />
            </span>
            <span class="load-more__text">
                <slot>WEITERE PRODUKTE LADEN</slot>
            </span>
        </button>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    loading: boolean;
    hasMore: boolean;
}>();

const emit = defineEmits<{
    load: [];
}>();
</script>

<style scoped>
.load-more {
    margin-top: 24px;
}

.load-more__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 14px 24px;
    border: none;
    border-radius: var(--m-radius);
    background: var(--m-primary);
    color: #fff;
    font-family: var(--m-font-body);
    font-size: 0.875rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(60, 143, 147, 0.25);
}

.load-more__btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(60, 143, 147, 0.35);
}

.load-more__btn:active:not(:disabled) {
    transform: translateY(0);
}

.load-more__btn--loading {
    opacity: 0.8;
    cursor: wait;
}

.load-more__icon {
    display: flex;
    align-items: center;
}

.load-more__text {
    display: flex;
    align-items: center;
    gap: 6px;
}

.load-more__spinner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: load-more-spin 0.6s linear infinite;
}

@keyframes load-more-spin {
    to { transform: rotate(360deg); }
}
</style>
